/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthenticationModule} from './auth/authentication.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarAltComponent } from './sidebar-alt/sidebar-alt.component';
import { AppRoutingModule } from '../app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner'

@NgModule({
	imports: [
		CommonModule, HttpClientModule, AuthenticationModule,
    TranslateModule,
		AppRoutingModule,
		NgxSpinnerModule
	],
	declarations: [
		FooterComponent,
		HeaderComponent,
		SidebarComponent,
		SidebarAltComponent,
	],
	exports: [
		FooterComponent,
		HeaderComponent,
		SidebarComponent,
		SidebarAltComponent
	],
	schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule { }
